<template>
  <div class="countdown-circle">
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path
        class="circle-bg"
        d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        :stroke-dasharray="`${progress}, 100`"
        d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="21.35" class="percentage">{{ timeSecondsCounter }}</text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CircleProgress',
  props: {
    timeSecondsCounter: {
      type: Number,
      required: true
    },
    totalTime: {
      type: Number,
      required: true
    }
  },
  computed: {
    progress() {
      return (this.timeSecondsCounter / this.totalTime) * 100
    }
  }
}
</script>

<style lang="less" scoped>
.countdown-circle {
  width: 40px;
  height: 40px;
}

.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 4.2;
}

.circle {
  fill: none;
  stroke-width: 4.0;
  stroke: @main-color;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.percentage {
  fill: #666;
  font-size: 0.9em;
  text-anchor: middle;
}
</style>
